import * as React from "react";
import { Card, CardContent } from "@/components/ui/card";
const partnersData = [{
  name: "Gulf Coast Harvesters",
  role: "Local Fishermen",
  description: "Generations of expertise ensuring only the finest wild-caught seafood makes it to our decks. Their commitment to sustainable practices mirrors our own.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/partner_fishermen.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/partner_fishermen.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/partner_fishermen.png-wvc-sizes",
  alt: "Gulf Coast Harvesters boat at sea"
}, {
  name: "Ocean Springs Ice & Supply",
  role: "Logistics & Preservation",
  description: "Providing the essential cold chain from the moment the catch is hauled aboard until it reaches your door, guaranteeing absolute freshness.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/partner_ice_supply.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/partner_ice_supply.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/partner_ice_supply.png-wvc-sizes",
  alt: "Ice supply facility and logistics"
}, {
  name: "Maritime Provisions Co.",
  role: "Packaging & Materials",
  description: "Crafting our signature vintage-inspired packaging using durable, eco-friendly materials that protect your order and honor our heritage.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/partner_provisions.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/partner_provisions.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/partner_provisions.webp-wvc-sizes",
  alt: "Vintage packaging materials and boxes"
}];
export default function Partners() {
  return <section id="our-partners" className="relative w-full bg-background py-24 md:py-40 overflow-hidden">
      {}
      <div className="hidden lg:block absolute left-8 top-1/2 -translate-y-1/2 -rotate-90 origin-left font-mono text-[10px] tracking-[0.25em] text-muted-foreground/40 whitespace-nowrap select-none">
        30° 24' 42" N // 88° 49' 42" W
      </div>

      <div className="max-w-[1440px] mx-auto px-6 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
          
          {}
          <div className="lg:col-span-4 flex flex-col justify-start">
            <span className="font-mono text-xs md:text-sm uppercase tracking-[0.25em] text-muted-foreground mb-6 block">
              04 // The Network
            </span>
            <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold text-foreground leading-[1.1] tracking-tight mb-8">
              Shared Standards.<br />Enduring Trust.
            </h2>
            
            {}
            <div className="flex items-center w-full mb-8">
              <div className="h-px bg-border flex-grow"></div>
              <div className="w-1.5 h-1.5 bg-foreground ml-1"></div>
            </div>

            <p className="font-sans text-lg text-muted-foreground leading-relaxed">
              We work with the finest local fishermen, processors, and suppliers who share our commitment to quality, sustainability, and the heritage of the Gulf Coast. These long-term relationships are the anchor of our promise to you.
            </p>
          </div>

          {}
          <div className="lg:col-span-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
              {partnersData.map((partner, index) => <Card key={partner.name} data-index={index} className="group rounded-md border-border bg-card shadow-sm hover:shadow-md hover:border-primary/50 transition-all duration-300 overflow-hidden flex flex-col">
                  <div className="aspect-[4/3] w-full overflow-hidden bg-muted relative">
                    <img src={partner.image} data-wvc-srcset={partner.srcset} data-wvc-sizes={partner.sizes} alt={partner.alt} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                    {}
                    <div className="absolute inset-0 bg-foreground/5 mix-blend-multiply pointer-events-none"></div>
                  </div>
                  
                  <CardContent className="p-6 md:p-8 flex-grow flex flex-col">
                    <span className="font-mono text-[10px] md:text-xs uppercase tracking-[0.2em] text-primary mb-3 block">
                      {partner.role}
                    </span>
                    <h3 className="font-default text-2xl font-semibold text-foreground mb-3 leading-tight">
                      {partner.name}
                    </h3>
                    <p className="font-sans text-muted-foreground text-sm md:text-base leading-relaxed mt-auto">
                      {partner.description}
                    </p>
                  </CardContent>
                </Card>)}
            </div>
          </div>

        </div>
      </div>
    </section>;
}